import React from 'react';
import mammoth from 'mammoth/mammoth.browser';
import { Buffer } from 'buffer';
import { Alert, Card, CardContent, styled } from '@mui/material';

import { type FilesViewerProps } from '../FilesViewer';
import useSettings from '../../hooks/useSettings';

const Root = styled('div')(({ theme }) => ({
	'*': {
		all: 'revert'
	},
	p: {
		// marginBlock: 'initial'
	}
}));

/** This component can display a Docx (MS Word) file */
function DocxViewer({ className, fileEncoded }: FilesViewerProps) {
	const { t } = useSettings();

	const [error, setError] = React.useState(false);

	React.useEffect(() => {
		mammoth
			.convertToHtml({ arrayBuffer: Buffer.from(fileEncoded, 'base64') })
			.then(result => {
				const docEl = document.getElementById('docx-viewer');
				if (docEl) docEl.innerHTML = result.value;
			})
			.catch(err => setError(true))
			.done();
	}, [fileEncoded]);

	return (
		<Card className="max-h-full overflow-auto rounded-8" variant="outlined">
			<CardContent sx={{ '&:last-child': { paddingBottom: '16px' } }}>
				{!error ? (
					<Root id="docx-viewer" className={className}>
						{t('LOADING')}
					</Root>
				) : (
					<Alert severity="error">{t('ERROR_FILE_READ')}</Alert>
				)}
			</CardContent>
		</Card>
	);
}

export default DocxViewer;
